import { tableStyles } from 'css/tableStyles';
import React from 'react';
import DataTable from 'components/DataTable';
import styles from './index.module.scss';

const columns = [
  {
    name: 'Name',
    selector: 'name',
    sortable: false,
  },
  {
    name: 'Unit',
    selector: 'unit',
    sortable: false,
    format: row => row.unit ? row.unit.description : '',
  },
  {
    name: 'Price',
    selector: 'price',
    sortable: false,
  },
  {
    name: 'Quantity',
    selector: 'quantity',
    sortable: false,
  },
  {
    name: 'Image',
    selector: 'objectId',
    sortable: false,
    // eslint-disable-next-line react/display-name
    cell: row => (
      <div className={styles['item-image']}>
        <img src={row.image?.url} alt={'Item Image'} />
      </div>
    ),
  },
];

const HomeBoxPreviewModal = ({ previewData, toggleModal }) => {
  const keys = Object.keys(previewData);

  const renderData = () => keys.map((key, i) => {
    const category = previewData[key];

    return (
      <div className={styles['single-category-table']} key={key+i}>
        <div className={styles['category-heading']}>{key}</div>
        <DataTable
          noHeader
          columns={columns}
          data={category}
          customStyles={tableStyles}
        />
      </div>
    );
  });
  
  return (
    <form className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          {renderData()}
        </div>
      </div>
    </form>
  );
};

export default HomeBoxPreviewModal;